<!-- TODO: Enlever le style -->
<!-- eslint-disable vue/no-static-inline-styles -->
<template>
  <div class="itemsContainer--uoZQl" style="padding-bottom: 0%">
    <div
      class="itemsRow--2Nmj9 skipRowsTransition--QL5CX"
      style="width: 100%; padding-bottom: 9.45455%; padding-left: 0%; padding-right: 0%; left: 0%"
    >
      <div
        v-for="(result, index) in results.slice(0, 8)"
        :key="index"
        class="itemContainer--1x-Md noTransition--1UEsy"
        :style="
          'width: 11.625%; padding-bottom: 8.45455%; transform: translateX(' +
          getTranslateX(index) +
          '%);'
        "
      >
        <img
          v-if="['ca', 'pa', 'bo'].includes(result)"
          :width="result == 'ca' ? '75.75757575757575%' : '72.72727272727273%'"
          :height="result == 'ca' ? '102.08333333333333%' : '100%'"
          :src="'data:image/svg+xml;base64,' + getImage(result)"
          alt="Crazy Time"
        />
        <div v-else-if="['fl_r', 'fl_b'].includes(result)" class="itemScale--3KxD1">
          <svg
            width="69.6969696969697%"
            height="95.83333333333334%"
            viewBox="0 0 48 48"
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient
                :id="'coinFlipIcon-' + result + '-history-a'"
                x1="50%"
                y1="101.9568%"
                x2="49.9959%"
                y2="0%"
              >
                <stop stop-color="#C3781B" offset="0%"></stop>
                <stop stop-color="#EBBB31" offset="19.332%"></stop>
                <stop stop-color="#F9E382" offset="49.351%"></stop>
                <stop stop-color="#EBBB31" offset="76.111%"></stop>
                <stop stop-color="#C3781B" offset="100%"></stop>
              </linearGradient>
              <linearGradient
                :id="'coinFlipIcon-' + result + '-history-b'"
                x1="49.9999%"
                y1="100.0001%"
                x2="49.9999%"
                y2="0%"
              >
                <stop stop-color="#FFF7C0" offset="0%"></stop>
                <stop stop-color="#FFC034" offset="49.027%"></stop>
                <stop stop-color="#FFF0C7" offset="100%"></stop>
              </linearGradient>
              <linearGradient
                :id="'coinFlipIcon-' + result + '-history-c'"
                x1="49.9543%"
                y1="99.9912%"
                x2="49.9543%"
                y2="-.014%"
              >
                <stop stop-color="#FFF7C0" offset="0%"></stop>
                <stop stop-color="#FFC034" offset="49.027%"></stop>
                <stop stop-color="#FFF0C7" offset="100%"></stop>
              </linearGradient>
              <linearGradient
                :id="'coinFlipIcon-' + result + '-history-d'"
                x1="41.2707%"
                y1=".7392%"
                x2="58.6379%"
                y2="99.238%"
              >
                <stop stop-color="#FFF0C7" offset="0%"></stop>
                <stop stop-color="#F3C936" offset="50.973%"></stop>
                <stop stop-color="#FFFDCF" offset="100%"></stop>
              </linearGradient>
              <linearGradient
                :id="'coinFlipIcon-' + result + '-history-e'"
                x1="49.9543%"
                y1="99.9912%"
                x2="49.9543%"
                y2="-.0141%"
              >
                <stop stop-color="#D08D06" offset="0%"></stop>
                <stop stop-color="#924822" offset="49.174%"></stop>
                <stop stop-color="#D08D06" offset="100%"></stop>
              </linearGradient>
              <linearGradient
                :id="'coinFlipIcon-' + result + '-history-f'"
                x1="91.9536%"
                y1="27.6295%"
                x2="14.5628%"
                y2="68.9056%"
              >
                <stop
                  :stop-color="result == 'fl_b' ? '#1C85EC' : '#EC1C31'"
                  offset="20.033%"
                ></stop>
                <stop :stop-color="result == 'fl_b' ? '#0533B1' : '#B10524'" offset="100%"></stop>
              </linearGradient>
              <linearGradient
                :id="'coinFlipIcon-' + result + '-history-g'"
                x1="39.5571%"
                y1="37.6575%"
                x2="58.0689%"
                y2="67.5623%"
              >
                <stop
                  :stop-color="result == 'fl_b' ? '#3C6CFC' : '#EC3749'"
                  stop-opacity="0"
                  offset="0%"
                ></stop>
                <stop
                  :stop-color="result == 'fl_b' ? '#3C6CFC' : '#EB3648'"
                  stop-opacity="0.0732"
                  offset="22.505%"
                ></stop>
                <stop
                  :stop-color="result == 'fl_b' ? '#3C6CFC' : '#E93346'"
                  stop-opacity="0.2642"
                  offset="39.673%"
                ></stop>
                <stop
                  :stop-color="result == 'fl_b' ? '#3C6CFC' : '#E62E42'"
                  stop-opacity="0.5693"
                  offset="63.41%"
                ></stop>
                <stop
                  :stop-color="result == 'fl_b' ? '#307CFB' : '#F33045'"
                  stop-opacity="0.8"
                  offset="100%"
                ></stop>
              </linearGradient>
            </defs>
            <g :id="'coinFlipIcon-' + result + '-history-Fill'" fill="none" fill-rule="evenodd">
              <path
                d="M29.4202 1.0824C16.763-1.8906 4.0915 5.9562 1.112 18.6117-1.8673 31.2673 5.973 43.943 18.627 46.9287c12.654 2.986 25.3337-4.8478 28.326-17.5003 2.986-12.6691-4.8638-25.36-17.5328-28.346z"
                :fill="'url(#coinFlipIcon-' + result + '-history-a)'"
              ></path>
              <path
                d="M29.5226.6496C16.6265-2.4004 3.6996 5.5814.6496 18.4775c-3.05 12.896 4.9319 25.8228 17.828 28.8729 12.896 3.05 25.8228-4.9318 28.8729-17.8279 3.0499-12.896-4.932-25.8228-17.828-28.873zm17.2396 28.7337c-2.164 9.2129-9.6662 16.214-19.0066 17.7368-9.3403 1.5228-18.6779-2.7328-23.656-10.7812-4.9783-8.0485-4.616-18.3037.9177-25.9809C10.551 2.6808 20.1656-.9053 29.3752 1.2728a23.372 23.372 0 0117.387 28.1105z"
                :fill="'url(#coinFlipIcon-' + result + '-history-b)'"
              ></path>
              <path
                d="M28.5986 4.556C17.86 2.0275 7.1044 8.681 4.5723 19.4189c-2.532 10.7378 4.118 21.4956 14.855 24.0312 10.737 2.5356 21.497-4.1109 24.0361-14.847C45.999 17.858 39.3439 7.0916 28.5986 4.556zm14.535 23.9691C40.6247 39.0874 30.03 45.6173 19.467 43.112 8.904 40.6065 2.3705 30.014 4.8725 19.4501 7.3745 8.886 17.9649 2.3493 28.5296 4.8479 39.1006 7.3535 45.639 17.954 43.1336 28.525z"
                :fill="'url(#coinFlipIcon-' + result + '-history-c)'"
              ></path>
              <path
                d="M28.483 5.0449C18.0144 2.5799 7.5292 9.0662 5.0608 19.534 2.5924 30.002 9.0752 40.4892 19.5422 42.961c10.467 2.4719 20.9566-4.0074 23.4318-14.4736 2.472-10.475-4.016-20.9706-14.491-23.4425zm12.5768 22.9897c-2.237 9.4175-11.6833 15.2397-21.1015 13.0058C10.5402 38.8066 4.715 29.3621 6.9457 19.9432 9.1765 10.5243 18.619 4.696 28.0387 6.9237c9.4252 2.234 15.2549 11.6857 13.021 21.111z"
                :fill="'url(#coinFlipIcon-' + result + '-history-d)'"
              ></path>
              <path
                d="M28.5198 4.8895C17.9653 2.4044 7.394 8.9438 4.9055 19.4975 2.417 30.051 8.953 40.6244 19.5057 43.1164c10.5528 2.492 21.1283-4.0403 23.6239-14.5923 2.4921-10.561-4.0489-21.1426-14.6098-23.6347zm14.2856 23.558c-2.4658 10.3811-12.8787 16.799-23.2606 14.3366-10.382-2.4624-16.8033-12.8733-14.3442-23.256C7.6596 9.1454 18.0684 2.7207 28.4519 5.1764 38.8416 7.639 45.268 18.0578 42.8054 28.4475z"
                :fill="'url(#coinFlipIcon-' + result + '-history-e)'"
              ></path>
              <ellipse
                :fill="'url(#coinFlipIcon-' + result + '-history-f)'"
                fill-rule="nonzero"
                transform="rotate(-76.627 24.0002 24)"
                cx="24.0001"
                cy="24.0001"
                rx="17.5544"
                ry="17.5298"
              ></ellipse>
              <path
                d="M36.3266 11.5083c-5.337-5.2549-13.4211-6.543-20.127-3.207-6.7059 3.336-10.555 10.5606-9.5834 17.9872 12.1273 2.5176 24.4028-3.5892 29.7104-14.7802z"
                :fill="'url(#coinFlipIcon-' + result + '-history-g)'"
              ></path>
              <path
                d="M28.0404 6.9169c-6.9093-1.6444-14.1288 1.0366-18.29 6.7923C5.589 19.4648 5.306 27.1607 9.033 33.2065c3.7272 6.0458 10.7301 9.25 17.7416 8.1177 7.0115-1.1322 12.65-6.3779 14.2846-13.2895A17.5421 17.5421 0 0028.0404 6.9169zM40.368 28.2937c-2.1265 8.935-11.0915 14.456-20.0274 12.3337-8.936-2.1222-14.4612-11.0847-12.3431-20.0216 2.118-8.9369 11.078-14.4664 20.0158-12.3525a16.647 16.647 0 0112.3547 20.0404z"
                fill="#0A0F8E"
              ></path>
            </g>
          </svg>
        </div>
        <div v-else-if="result == 'fl'" class="itemScale--3KxD1">
          <div class="container--3vrCq">
            <div class="innerContainer--3I5ER">
              <div class="coin--1JNQ1">
                <div class="front--1KBn9">
                  <svg
                    width="69.6969696969697%"
                    height="95.83333333333334%"
                    viewBox="0 0 48 48"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <linearGradient
                        id="coinFlipIcon-history-front-a"
                        x1="50%"
                        y1="101.9568%"
                        x2="49.9959%"
                        y2="0%"
                      >
                        <stop stop-color="#C3781B" offset="0%"></stop>
                        <stop stop-color="#EBBB31" offset="19.332%"></stop>
                        <stop stop-color="#F9E382" offset="49.351%"></stop>
                        <stop stop-color="#EBBB31" offset="76.111%"></stop>
                        <stop stop-color="#C3781B" offset="100%"></stop>
                      </linearGradient>
                      <linearGradient
                        id="coinFlipIcon-history-front-b"
                        x1="49.9999%"
                        y1="100.0001%"
                        x2="49.9999%"
                        y2="0%"
                      >
                        <stop stop-color="#FFF7C0" offset="0%"></stop>
                        <stop stop-color="#FFC034" offset="49.027%"></stop>
                        <stop stop-color="#FFF0C7" offset="100%"></stop>
                      </linearGradient>
                      <linearGradient
                        id="coinFlipIcon-history-front-c"
                        x1="49.9543%"
                        y1="99.9912%"
                        x2="49.9543%"
                        y2="-.014%"
                      >
                        <stop stop-color="#FFF7C0" offset="0%"></stop>
                        <stop stop-color="#FFC034" offset="49.027%"></stop>
                        <stop stop-color="#FFF0C7" offset="100%"></stop>
                      </linearGradient>
                      <linearGradient
                        id="coinFlipIcon-history-front-d"
                        x1="41.2707%"
                        y1=".7392%"
                        x2="58.6379%"
                        y2="99.238%"
                      >
                        <stop stop-color="#FFF0C7" offset="0%"></stop>
                        <stop stop-color="#F3C936" offset="50.973%"></stop>
                        <stop stop-color="#FFFDCF" offset="100%"></stop>
                      </linearGradient>
                      <linearGradient
                        id="coinFlipIcon-history-front-e"
                        x1="49.9543%"
                        y1="99.9912%"
                        x2="49.9543%"
                        y2="-.0141%"
                      >
                        <stop stop-color="#D08D06" offset="0%"></stop>
                        <stop stop-color="#924822" offset="49.174%"></stop>
                        <stop stop-color="#D08D06" offset="100%"></stop>
                      </linearGradient>
                      <linearGradient
                        id="coinFlipIcon-history-front-f"
                        x1="91.9536%"
                        y1="27.6295%"
                        x2="14.5628%"
                        y2="68.9056%"
                      >
                        <stop stop-color="#EC1C31" offset="20.033%"></stop>
                        <stop stop-color="#B10524" offset="100%"></stop>
                      </linearGradient>
                      <linearGradient
                        id="coinFlipIcon-history-front-g"
                        x1="39.5571%"
                        y1="37.6575%"
                        x2="58.0689%"
                        y2="67.5623%"
                      >
                        <stop stop-color="#EC3749" stop-opacity="0" offset="0%"></stop>
                        <stop stop-color="#EB3648" stop-opacity="0.0732" offset="22.505%"></stop>
                        <stop stop-color="#E93346" stop-opacity="0.2642" offset="39.673%"></stop>
                        <stop stop-color="#E62E42" stop-opacity="0.5693" offset="63.41%"></stop>
                        <stop stop-color="#F33045" stop-opacity="0.8" offset="100%"></stop>
                      </linearGradient>
                    </defs>
                    <g id="coinFlipIcon-history-front-Fill" fill="none" fill-rule="evenodd">
                      <path
                        d="M29.4202 1.0824C16.763-1.8906 4.0915 5.9562 1.112 18.6117-1.8673 31.2673 5.973 43.943 18.627 46.9287c12.654 2.986 25.3337-4.8478 28.326-17.5003 2.986-12.6691-4.8638-25.36-17.5328-28.346z"
                        fill="url(#coinFlipIcon-history-front-a)"
                      ></path>
                      <path
                        d="M29.5226.6496C16.6265-2.4004 3.6996 5.5814.6496 18.4775c-3.05 12.896 4.9319 25.8228 17.828 28.8729 12.896 3.05 25.8228-4.9318 28.8729-17.8279 3.0499-12.896-4.932-25.8228-17.828-28.873zm17.2396 28.7337c-2.164 9.2129-9.6662 16.214-19.0066 17.7368-9.3403 1.5228-18.6779-2.7328-23.656-10.7812-4.9783-8.0485-4.616-18.3037.9177-25.9809C10.551 2.6808 20.1656-.9053 29.3752 1.2728a23.372 23.372 0 0117.387 28.1105z"
                        fill="url(#coinFlipIcon-history-front-b)"
                      ></path>
                      <path
                        d="M28.5986 4.556C17.86 2.0275 7.1044 8.681 4.5723 19.4189c-2.532 10.7378 4.118 21.4956 14.855 24.0312 10.737 2.5356 21.497-4.1109 24.0361-14.847C45.999 17.858 39.3439 7.0916 28.5986 4.556zm14.535 23.9691C40.6247 39.0874 30.03 45.6173 19.467 43.112 8.904 40.6065 2.3705 30.014 4.8725 19.4501 7.3745 8.886 17.9649 2.3493 28.5296 4.8479 39.1006 7.3535 45.639 17.954 43.1336 28.525z"
                        fill="url(#coinFlipIcon-history-front-c)"
                      ></path>
                      <path
                        d="M28.483 5.0449C18.0144 2.5799 7.5292 9.0662 5.0608 19.534 2.5924 30.002 9.0752 40.4892 19.5422 42.961c10.467 2.4719 20.9566-4.0074 23.4318-14.4736 2.472-10.475-4.016-20.9706-14.491-23.4425zm12.5768 22.9897c-2.237 9.4175-11.6833 15.2397-21.1015 13.0058C10.5402 38.8066 4.715 29.3621 6.9457 19.9432 9.1765 10.5243 18.619 4.696 28.0387 6.9237c9.4252 2.234 15.2549 11.6857 13.021 21.111z"
                        fill="url(#coinFlipIcon-history-front-d)"
                      ></path>
                      <path
                        d="M28.5198 4.8895C17.9653 2.4044 7.394 8.9438 4.9055 19.4975 2.417 30.051 8.953 40.6244 19.5057 43.1164c10.5528 2.492 21.1283-4.0403 23.6239-14.5923 2.4921-10.561-4.0489-21.1426-14.6098-23.6347zm14.2856 23.558c-2.4658 10.3811-12.8787 16.799-23.2606 14.3366-10.382-2.4624-16.8033-12.8733-14.3442-23.256C7.6596 9.1454 18.0684 2.7207 28.4519 5.1764 38.8416 7.639 45.268 18.0578 42.8054 28.4475z"
                        fill="url(#coinFlipIcon-history-front-e)"
                      ></path>
                      <ellipse
                        fill="url(#coinFlipIcon-history-front-f)"
                        fill-rule="nonzero"
                        transform="rotate(-76.627 24.0002 24)"
                        cx="24.0001"
                        cy="24.0001"
                        rx="17.5544"
                        ry="17.5298"
                      ></ellipse>
                      <path
                        d="M36.3266 11.5083c-5.337-5.2549-13.4211-6.543-20.127-3.207-6.7059 3.336-10.555 10.5606-9.5834 17.9872 12.1273 2.5176 24.4028-3.5892 29.7104-14.7802z"
                        fill="url(#coinFlipIcon-history-front-g)"
                      ></path>
                      <path
                        d="M28.0404 6.9169c-6.9093-1.6444-14.1288 1.0366-18.29 6.7923C5.589 19.4648 5.306 27.1607 9.033 33.2065c3.7272 6.0458 10.7301 9.25 17.7416 8.1177 7.0115-1.1322 12.65-6.3779 14.2846-13.2895A17.5421 17.5421 0 0028.0404 6.9169zM40.368 28.2937c-2.1265 8.935-11.0915 14.456-20.0274 12.3337-8.936-2.1222-14.4612-11.0847-12.3431-20.0216 2.118-8.9369 11.078-14.4664 20.0158-12.3525a16.647 16.647 0 0112.3547 20.0404z"
                        fill="#8E0A26"
                      ></path>
                    </g>
                  </svg>
                </div>
                <div class="back--2YB63">
                  <svg
                    width="69.6969696969697%"
                    height="95.83333333333334%"
                    viewBox="0 0 48 48"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <defs>
                      <linearGradient
                        id="coinFlipIcon-history-back-a"
                        x1="50%"
                        y1="101.9568%"
                        x2="49.9959%"
                        y2="0%"
                      >
                        <stop stop-color="#C3781B" offset="0%"></stop>
                        <stop stop-color="#EBBB31" offset="19.332%"></stop>
                        <stop stop-color="#F9E382" offset="49.351%"></stop>
                        <stop stop-color="#EBBB31" offset="76.111%"></stop>
                        <stop stop-color="#C3781B" offset="100%"></stop>
                      </linearGradient>
                      <linearGradient
                        id="coinFlipIcon-history-back-b"
                        x1="49.9999%"
                        y1="100.0001%"
                        x2="49.9999%"
                        y2="0%"
                      >
                        <stop stop-color="#FFF7C0" offset="0%"></stop>
                        <stop stop-color="#FFC034" offset="49.027%"></stop>
                        <stop stop-color="#FFF0C7" offset="100%"></stop>
                      </linearGradient>
                      <linearGradient
                        id="coinFlipIcon-history-back-c"
                        x1="49.9543%"
                        y1="99.9912%"
                        x2="49.9543%"
                        y2="-.014%"
                      >
                        <stop stop-color="#FFF7C0" offset="0%"></stop>
                        <stop stop-color="#FFC034" offset="49.027%"></stop>
                        <stop stop-color="#FFF0C7" offset="100%"></stop>
                      </linearGradient>
                      <linearGradient
                        id="coinFlipIcon-history-back-d"
                        x1="41.2707%"
                        y1=".7392%"
                        x2="58.6379%"
                        y2="99.238%"
                      >
                        <stop stop-color="#FFF0C7" offset="0%"></stop>
                        <stop stop-color="#F3C936" offset="50.973%"></stop>
                        <stop stop-color="#FFFDCF" offset="100%"></stop>
                      </linearGradient>
                      <linearGradient
                        id="coinFlipIcon-history-back-e"
                        x1="49.9543%"
                        y1="99.9912%"
                        x2="49.9543%"
                        y2="-.0141%"
                      >
                        <stop stop-color="#D08D06" offset="0%"></stop>
                        <stop stop-color="#924822" offset="49.174%"></stop>
                        <stop stop-color="#D08D06" offset="100%"></stop>
                      </linearGradient>
                      <linearGradient
                        id="coinFlipIcon-history-back-f"
                        x1="91.9536%"
                        y1="27.6295%"
                        x2="14.5628%"
                        y2="68.9056%"
                      >
                        <stop stop-color="#1C85EC" offset="20.033%"></stop>
                        <stop stop-color="#0533B1" offset="100%"></stop>
                      </linearGradient>
                      <linearGradient
                        id="coinFlipIcon-history-back-g"
                        x1="39.5571%"
                        y1="37.6575%"
                        x2="58.0689%"
                        y2="67.5623%"
                      >
                        <stop stop-color="#3C6CFC" stop-opacity="0" offset="0%"></stop>
                        <stop stop-color="#3C6CFC" stop-opacity="0.0732" offset="22.505%"></stop>
                        <stop stop-color="#3C6CFC" stop-opacity="0.2642" offset="39.673%"></stop>
                        <stop stop-color="#3C6CFC" stop-opacity="0.5693" offset="63.41%"></stop>
                        <stop stop-color="#307CFB" stop-opacity="0.8" offset="100%"></stop>
                      </linearGradient>
                    </defs>
                    <g id="coinFlipIcon-history-back-Fill" fill="none" fill-rule="evenodd">
                      <path
                        d="M29.4202 1.0824C16.763-1.8906 4.0915 5.9562 1.112 18.6117-1.8673 31.2673 5.973 43.943 18.627 46.9287c12.654 2.986 25.3337-4.8478 28.326-17.5003 2.986-12.6691-4.8638-25.36-17.5328-28.346z"
                        fill="url(#coinFlipIcon-history-back-a)"
                      ></path>
                      <path
                        d="M29.5226.6496C16.6265-2.4004 3.6996 5.5814.6496 18.4775c-3.05 12.896 4.9319 25.8228 17.828 28.8729 12.896 3.05 25.8228-4.9318 28.8729-17.8279 3.0499-12.896-4.932-25.8228-17.828-28.873zm17.2396 28.7337c-2.164 9.2129-9.6662 16.214-19.0066 17.7368-9.3403 1.5228-18.6779-2.7328-23.656-10.7812-4.9783-8.0485-4.616-18.3037.9177-25.9809C10.551 2.6808 20.1656-.9053 29.3752 1.2728a23.372 23.372 0 0117.387 28.1105z"
                        fill="url(#coinFlipIcon-history-back-b)"
                      ></path>
                      <path
                        d="M28.5986 4.556C17.86 2.0275 7.1044 8.681 4.5723 19.4189c-2.532 10.7378 4.118 21.4956 14.855 24.0312 10.737 2.5356 21.497-4.1109 24.0361-14.847C45.999 17.858 39.3439 7.0916 28.5986 4.556zm14.535 23.9691C40.6247 39.0874 30.03 45.6173 19.467 43.112 8.904 40.6065 2.3705 30.014 4.8725 19.4501 7.3745 8.886 17.9649 2.3493 28.5296 4.8479 39.1006 7.3535 45.639 17.954 43.1336 28.525z"
                        fill="url(#coinFlipIcon-history-back-c)"
                      ></path>
                      <path
                        d="M28.483 5.0449C18.0144 2.5799 7.5292 9.0662 5.0608 19.534 2.5924 30.002 9.0752 40.4892 19.5422 42.961c10.467 2.4719 20.9566-4.0074 23.4318-14.4736 2.472-10.475-4.016-20.9706-14.491-23.4425zm12.5768 22.9897c-2.237 9.4175-11.6833 15.2397-21.1015 13.0058C10.5402 38.8066 4.715 29.3621 6.9457 19.9432 9.1765 10.5243 18.619 4.696 28.0387 6.9237c9.4252 2.234 15.2549 11.6857 13.021 21.111z"
                        fill="url(#coinFlipIcon-history-back-d)"
                      ></path>
                      <path
                        d="M28.5198 4.8895C17.9653 2.4044 7.394 8.9438 4.9055 19.4975 2.417 30.051 8.953 40.6244 19.5057 43.1164c10.5528 2.492 21.1283-4.0403 23.6239-14.5923 2.4921-10.561-4.0489-21.1426-14.6098-23.6347zm14.2856 23.558c-2.4658 10.3811-12.8787 16.799-23.2606 14.3366-10.382-2.4624-16.8033-12.8733-14.3442-23.256C7.6596 9.1454 18.0684 2.7207 28.4519 5.1764 38.8416 7.639 45.268 18.0578 42.8054 28.4475z"
                        fill="url(#coinFlipIcon-history-back-e)"
                      ></path>
                      <ellipse
                        fill="url(#coinFlipIcon-history-back-f)"
                        fill-rule="nonzero"
                        transform="rotate(-76.627 24.0002 24)"
                        cx="24.0001"
                        cy="24.0001"
                        rx="17.5544"
                        ry="17.5298"
                      ></ellipse>
                      <path
                        d="M36.3266 11.5083c-5.337-5.2549-13.4211-6.543-20.127-3.207-6.7059 3.336-10.555 10.5606-9.5834 17.9872 12.1273 2.5176 24.4028-3.5892 29.7104-14.7802z"
                        fill="url(#coinFlipIcon-history-back-g)"
                      ></path>
                      <path
                        d="M28.0404 6.9169c-6.9093-1.6444-14.1288 1.0366-18.29 6.7923C5.589 19.4648 5.306 27.1607 9.033 33.2065c3.7272 6.0458 10.7301 9.25 17.7416 8.1177 7.0115-1.1322 12.65-6.3779 14.2846-13.2895A17.5421 17.5421 0 0028.0404 6.9169zM40.368 28.2937c-2.1265 8.935-11.0915 14.456-20.0274 12.3337-8.936-2.1222-14.4612-11.0847-12.3431-20.0216 2.118-8.9369 11.078-14.4664 20.0158-12.3525a16.647 16.647 0 0112.3547 20.0404z"
                        fill="#0A0F8E"
                      ></path>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="itemScale--3KxD1">
          <svg
            width="75.75757575757575%"
            height="91.66666666666666%"
            viewBox="0 0 52 46"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <defs>
              <path
                :id="'icon-' + result + '-history-a'"
                d="M39.8787 41.587c8.6288-1.1426 9.2154-5.7204 9.6018-7.3204.3284-1.3591 1.9143-16.4272 2.356-19.6471.3995-2.9056 1.215-9.3514-13.5015-10.5507C33.0446 3.6368 29.867 3.0172 26.0306 0c-3.8363 3.0172-7.014 3.6367-12.3044 4.0688C-.9903 5.2681-.2421 11.714.1575 14.6195c.4416 3.2199 2.0553 18.288 2.3837 19.647.3864 1.6 1.0125 6.1779 9.6413 7.3205C23.6431 43.106 25.9428 45.8883 26.0306 46c.0887-.1117 2.3875-2.894 13.848-4.413z"
              ></path>
              <linearGradient
                :id="'icon-' + result + '-history-b'"
                x1="50%"
                y1="0%"
                x2="50%"
                y2="100%"
              >
                <stop :stop-color="getCouleur(result)" offset="0%"></stop>
                <stop :stop-color="getCouleurGradiant(result)" offset="58.1239%"></stop>
                <stop :stop-color="getCouleurGradiant(result)" offset="100%"></stop>
              </linearGradient>
              <path
                :id="'icon-' + result + '-history-c'"
                :fill="'url(\'#icon-' + result + '-history-b\')'"
                d="M26.0303 41.2935c-3.023-1.574-7.496-2.761-13.324-3.533-5.461-.724-5.911-2.694-6.209-3.996l-.064-.277c-.167-.784-.959-7.698-1.384-11.412l-.033-.283c-.371-3.24-.722-6.3-.897-7.579-.202-1.465-.194-2.29.393-3.023.573-.713 2.65-2.435 9.538-2.997 4.925-.401 8.425-1.059 11.979-3.193 3.554 2.134 7.054 2.792 11.98 3.193 6.855.559 8.916 2.265 9.484 2.972.579.722.583 1.558.379 3.049-.175 1.274-.498 4.123-.937 8.009-.446 3.946-1.186 10.499-1.351 11.273l-.066.282c-.295 1.306-.737 3.263-6.167 3.982-5.826.772-10.298 1.959-13.321 3.533"
              ></path>
            </defs>
            <g fill="none" fill-rule="evenodd">
              <g>
                <use
                  fill-opacity=".65"
                  fill="#000000"
                  :xlink:href="'#icon-' + result + '-history-a'"
                ></use>
                <path
                  :stroke="'url(\'#icon-' + result + '-history-b\')'"
                  stroke-width="2"
                  d="M26.0311 1.2571c-3.7359 2.7482-6.9803 3.3801-12.2235 3.8084-5.4309.4426-8.6696 1.593-10.5496 3.0548-2.7147 2.1109-2.3212 4.826-2.1099 6.363.1745 1.2718.5313 4.3855.9197 7.7768.5904 5.1547 1.2494 10.9602 1.506 12.0325.2183.9554.6017 2.7215 2.5473 4.1571 1.2972.9573 3.2495 1.7562 6.1927 2.146 8.677 1.15 12.3149 3.045 13.7161 4.0728 1.3982-1.0256 5.0341-2.922 13.7174-4.0728 2.9354-.3888 4.8801-1.1843 6.1705-2.1384 1.9451-1.438 2.3149-3.2126 2.5907-4.4256.1949-.8066.8308-6.4942 1.4082-11.6036.3905-3.4562.7518-6.652.9291-7.9445.2114-1.5377.6313-4.256-2.0715-6.3682-1.8682-1.4599-5.0959-2.6078-10.5205-3.0499-5.243-.4282-8.4874-1.0601-12.2227-3.8084z"
                  stroke-linecap="square"
                  fill-opacity=".25"
                  :fill="getCouleur(result)"
                ></path>
              </g>
              <g v-if="index == 0">
                <use
                  fill-opacity=".5"
                  fill="#000"
                  :xlink:href="'#icon-' + result + '-history-c'"
                ></use>
                <use :xlink:href="'#icon-' + result + '-history-c'"></use>
              </g>
              <text
                font-family="Inter"
                font-size="25"
                font-weight="400"
                :fill="index == 0 ? '#4A4A4A' : getCouleur(result)"
              >
                <tspan x="50%" y="55%" text-anchor="middle" dominant-baseline="middle">
                  {{ result }}
                </tspan>
              </text>
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const CS_COULEUR_BLEU = '#BBE6E4';
const CS_COULEUR_JAUNE = '#FFDD89';
const CS_COULEUR_ROSE = '#FCCBDA';
const CS_COULEUR_MAUVE = '#D2CAF5';

const CS_COULEUR_BLEU_GRADIANT = '#81CACB';
const CS_COULEUR_JAUNE_GRADIANT = '#F7C257';
const CS_COULEUR_ROSE_GRADIANT = '#ECA3B8';
const CS_COULEUR_MAUVE_GRADIANT = '#A094E0';

const CS_CASH_HUNT =
  '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';
const CS_PACHINKO =
  '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';
const CS_CRAZY_BONUS =
  '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';

export default {
  name: 'CarteInfoSecondaireCEDCrazyTime',
  props: {
    results: {
      type: Array,
      required: true,
    },
    // appareil: {
    //   type: String,
    //   required: true,
    // },
    // prefixeUrl: {
    //   type: String,
    //   required: true,
    // },
  },
  methods: {
    // retourne l'indentation de chaque affichage
    getTranslateX(index) {
      return index * 108.602;
    },
    // retourne la couleur primaire de l'Ã©lÃ©ment
    getCouleur(result) {
      if (result == '1') {
        return CS_COULEUR_BLEU;
      }
      if (result == '2') {
        return CS_COULEUR_JAUNE;
      }
      if (result == '5') {
        return CS_COULEUR_ROSE;
      }
      if (result == '10') {
        return CS_COULEUR_MAUVE;
      }
      // erreur
      return '#fff';
    },
    // retourne la couleur secondaire de l'Ã©lÃ©ment
    getCouleurGradiant(result) {
      if (result == '1') {
        return CS_COULEUR_BLEU_GRADIANT;
      }
      if (result == '2') {
        return CS_COULEUR_JAUNE_GRADIANT;
      }
      if (result == '5') {
        return CS_COULEUR_ROSE_GRADIANT;
      }
      if (result == '10') {
        return CS_COULEUR_MAUVE_GRADIANT;
      }
      // erreur
      return '#fff';
    },
    // retourne le lien de l'image à afficher
    getImage(result) {
      if (result == 'ca') {
        return CS_CASH_HUNT;
      }
      if (result == 'pa') {
        return CS_PACHINKO;
      }
      // result == "bo"
      return CS_CRAZY_BONUS;
    },
  },
};
</script>

<style>
.itemsContainer--uoZQl {
  position: relative;
  width: 100%;
  height: 100%;
}

.itemsRow--2Nmj9 {
  transition: opacity 0.5s linear;
  opacity: 1;
  position: relative;
  direction: ltr;
}

.itemsRow--2Nmj9.skipRowsTransition--QL5CX {
  transition: none;
}

.itemsRow--2Nmj9.hiddenRow--ENOlV {
  opacity: 0;
}

.itemsRow--2Nmj9.fadeElements--34koz {
  overflow: hidden;
  -webkit-mask-image: linear-gradient(
    90deg,
    rgba(74, 74, 74, 0.3),
    #4a4a4a 1.2%,
    #4a4a4a 98.8%,
    rgba(74, 74, 74, 0.3)
  );
  mask-image: linear-gradient(
    90deg,
    rgba(74, 74, 74, 0.3),
    #4a4a4a 1.2%,
    #4a4a4a 98.8%,
    rgba(74, 74, 74, 0.3)
  );
}

.itemsRow--2Nmj9.isScrollable--3zo-M {
  overflow: hidden;
}

.itemContainer--1x-Md {
  position: absolute;
  pointer-events: all;
  transition: -webkit-transform 0.25s ease-out;
  transition: transform 0.25s ease-out;
  transition: transform 0.25s ease-out, -webkit-transform 0.25s ease-out;
}

.itemContainer--1x-Md.noTransition--1UEsy {
  transition-property: none;
}

.itemScale--3KxD1 {
  width: 100%;
  height: 100%;
  position: absolute;
  -webkit-animation-duration: 0.35s;
  animation-duration: 0.35s;
  -webkit-transform: scale(1);
  transform: scale(1);
}

.container--3vrCq {
  position: absolute;
  width: 100%;
  height: 100%;
}

.innerContainer--3I5ER {
  -webkit-perspective: 600px;
  perspective: 600px;
  height: 100%;
  width: 100%;
}

.coin--1JNQ1 {
  position: relative;
  height: 100%;
  -webkit-animation-name: rotationKeyframes--26fJ5;
  animation-name: rotationKeyframes--26fJ5;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
  -webkit-animation-delay: 0.3s;
  animation-delay: 0.3s;
  -webkit-transform: rotateY(0deg);
  transform: rotateY(0deg);
  -webkit-transform-style: preserve-3d;
  transform-style: preserve-3d;
}

.back--2YB63,
.front--1KBn9 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}

.front--1KBn9 {
  -webkit-transform: rotateY(0deg);
  transform: rotateY(0deg);
}

.back--2YB63 {
  -webkit-transform: rotateY(180deg);
  transform: rotateY(180deg);
}

@keyframes rotationKeyframes--26fJ5 {
  0% {
    -webkit-transform: rotateY(0deg);
    transform: rotateY(0deg);
  }

  50% {
    -webkit-transform: rotateY(180deg);
    transform: rotateY(180deg);
  }

  to {
    -webkit-transform: rotateY(1turn);
    transform: rotateY(1turn);
  }
}
</style>
